module.exports = __webpack_public_path__ + "img/logo.634b0b28.png";